<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12">
        <v-toolbar color="transparent" flat>
          <v-text-field 
            v-model="search" 
            color="secondary" 
            :placeholder="$t('Global.Common.search')" 
            hide-details 
            prepend-inner-icon="find_in_page"
            :loading="loading || searchTimerId !== null"
          >
          </v-text-field>
        </v-toolbar>
        <v-slide-y-transition mode="out-in">
          <template v-if="!neverLoaded">
            <v-list v-if="documents.length && !loading" key="list" style="overflow-y: auto;" color="transparent">
              <v-list-item v-for="(doc, index) in documents" :key="'document' + index" :href="doc.href">
                <v-list-item-avatar>
                  <v-icon large color="primary">insert_drive_file</v-icon>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title class="primary--text">{{doc.title}} </v-list-item-title>
                </v-list-item-content>

                <v-list-item-action class="mr-4">
                  <span class="font-weight-thin">{{doc.prettySize}}</span>
                </v-list-item-action>

                <v-list-item-action>
                  {{doc.prettyDate}}
                </v-list-item-action>

                <v-list-item-action>
                  <v-icon large color="secondary">get_app</v-icon>
                </v-list-item-action>
              </v-list-item>
            </v-list>
            <v-alert v-else color="primary" text icon="info" key="alert">
              {{ $t('Document.Manager.empty') }}
            </v-alert>
          </template>
        </v-slide-y-transition>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { DocumentRepository } from '@portal/api'
import prettyBytes from 'pretty-bytes'
import FileMixin from '@/mixins/FileMixin'
export default {
  mixins: [FileMixin],
  props: {
    isPublic: {type: Boolean, required: false, default: false}
  },
  data: () => ({
    documents: [],
    search: '',
    loading: false,
    neverLoaded: true,
    searchTimerId: null,
  }),
  watch: {
    search () {
      clearTimeout(this.searchTimerId)
      this.searchTimerId = setTimeout(async () => {
        this.fetchDocuments()
        this.searchTimerId = null
      }, 500)
    }
  },
  methods: {
    async fetchDocuments () {
      this.loading = true

      const documents = await DocumentRepository.fetchAll({title: this.search, isPublic: this.isPublic})
      this.documents = documents.map(doc => ({
        ...doc, 
        prettySize: prettyBytes(doc.fileSize),
        prettyDate: (new Date(doc.updatedAt)).toLocaleString('fr-FR', {day: 'numeric', month: 'long', year: 'numeric'}),
        href: this.$_file_getDocumentPath(doc.id)
      }))
      this.loading = false
    }
  },
  async created () {
    await this.fetchDocuments()
    this.neverLoaded = false
  }
}
</script>